import logo from './logo.svg';
import './App.css';
import Header from './Header/Header';
import Shop from './Shop/Shop';
import Answers from './Answers/Answers';

function App() {
  return (
    <div className='App'>
      <Header></Header>
      <Shop></Shop>
      <Answers></Answers>
    </div>
  );
}

export default App;
